(function () {
  function initBiscottiTabs(section) {
    var tabs = section.querySelectorAll('[data-biscotti-tab]');
    var panels = section.querySelectorAll('[data-biscotti-panel]');
    if (!tabs.length || !panels.length) return;

    function activate(id) {
      tabs.forEach(function (tab) {
        var isActive = tab.getAttribute('data-biscotti-tab') === id;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
      panels.forEach(function (panel) {
        var isActive = panel.getAttribute('data-biscotti-panel') === id;
        panel.classList.toggle('is-active', isActive);
        panel.hidden = !isActive;
      });
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activate(tab.getAttribute('data-biscotti-tab'));
      });
    });
  }

  function boot() {
    document.querySelectorAll('.lb-flavors--reimagined').forEach(initBiscottiTabs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.lb-flavors--reimagined');
    if (section) initBiscottiTabs(section);
  });
})();
